import { useEffect }   from 'react';
import { store }       from 'index';
import { initialLang } from 'utils/constants'
import { SET_LANG }    from 'actions/componentsActions';

const useSetLang = () => {

    useEffect(() => {

        let unmounted = false;
        if (!!initialLang && !unmounted) {
          store.dispatch(SET_LANG(initialLang))
        }
        return () => { unmounted = true };

    },[])
}

export default useSetLang